import {EnqueueSnackbar, SnackbarAction, useSnackbar} from "notistack";
import {useMemo} from "react";
import {apiErrorMessage} from "../ApiErrorMessage";

export class Message {
    private readonly enqueueSnackbar: EnqueueSnackbar;

    constructor(enqueueSnackbar: EnqueueSnackbar) {
        this.enqueueSnackbar = enqueueSnackbar;
    }

    success(message: string, action?: SnackbarAction, autoHideDuration?: number) {
        this.enqueueSnackbar({
            message,
            variant: 'success',
            autoHideDuration,
            action,
        });
    }

    error(message: string, e?: any) {
        this.enqueueSnackbar({
            message: (e && apiErrorMessage(e)) || message,
            variant: 'error'
        });
    }

    message(message: string) {
        this.enqueueSnackbar({
            message,
            variant: 'default'
        });
    }

    async exec(operation: () => Promise<any>, successMessage: string, errorMessage: string) {
        try {
            await operation();
            this.success(successMessage);
        } catch (e) {
            this.error(errorMessage, e);
        }
    }
}


export function useMessage() {
    const {enqueueSnackbar} = useSnackbar();

    return useMemo(
        () => new Message(enqueueSnackbar),
        [enqueueSnackbar]
    );
}
